import { render } from "./Portfolio.vue?vue&type=template&id=296b3575&ts=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__